var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9124 1H17.0876C17.5913 1 18 1.47682 18 2.06444V6.93556C18 7.52318 17.5913 8 17.0876 8H12.9124C12.4087 8 12 7.52318 12 6.93556V2.06444C12 1.47682 12.4087 1 12.9124 1Z",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9124 17H17.0876C17.5913 17 18 17.4087 18 17.9124V22.0876C18 22.5913 17.5913 23 17.0876 23H12.9124C12.4087 23 12 22.5913 12 22.0876V17.9124C12 17.4087 12.4087 17 12.9124 17Z",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91238 17H6.08762C6.59129 17 7 17.4087 7 17.9124V22.0876C7 22.5913 6.59129 23 6.08762 23H1.91238C1.40871 23 1 22.5913 1 22.0876V17.9124C1 17.4087 1.40871 17 1.91238 17Z",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0876 23H24.9124C24.4087 23 24 22.5913 24 22.0876V17.9124C24 17.4087 24.4087 17 24.9124 17H29.0876C29.5913 17 30 17.4087 30 17.9124V22.0876C30 22.5913 29.5913 23 29.0876 23Z",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17V13.3507C4 12.6042 4.55346 12 5.23725 12H25.7627C26.4465 12 27 12.6042 27 13.3507V17",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17V8",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.d6ba05cc256a3a2ffd9253c41c8212ab.svg";
export { ForwardRef as ReactComponent };